export interface InlineTableData {
  new: boolean;
  id: string | number;
}